import styled from 'styled-components';
import { DEVICES } from '_constants';
import { DIRECTIONS_BACKGROUND } from 'assets/icons';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;

  @media ${DEVICES.laptop} {
    align-items: flex-start;
  }
`;

export const HeaderBox = styled.div`
  margin: 0 0 0 24px;
  display: flex;

  @media ${DEVICES.mobileXL} {
    flex-direction: column;

    button {
      width: 150px;
    }

    button:last-of-type {
      margin: 0;
      margin-top: 10px;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 24px;

  @media ${DEVICES.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FilterWrapper = styled.div`
  margin: 0 0 15px;
`;

export const ChipsWrapper = styled.div`
  width: calc(100% - 325px);
  margin: 0 0 24px;

  @media ${DEVICES.tablet} {
    width: 100%;
  }
`;

export const TableContainer = styled.div``;

export const Wrapper = styled.div`
  display: ${({ isShow }) => isShow && 'none'};

  box-sizing: border-box;
  padding: 24px;

  @media ${DEVICES.tablet} {
    padding: 24px 5px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  margin-bottom: 25px;
  align-items: center;
  justify-content: space-between;
  max-width: 310px;
`;

export const H1 = styled.h1`
  font-size: 22px;
  line-height: 26px;
  font-family: Roboto;
  font-style: normal;
  display: block;
  font-weight: 500;
  @media print {
    margin: 0;
  }
`;

export const DirectionsBtnWrapper = styled.div`
  position: absolute;
  top: 150px;
  left: calc(100% - 325px);
  height: 200px;
  width: 300px;
  background: transparent url(${DIRECTIONS_BACKGROUND}) no-repeat center center;
  background-size: 110%;
  background-position: 60% 60%;
  border-radius: 4px;
  border: 2px solid #f0eae8;

  @media ${DEVICES.tablet} {
    position: relative;
    top: 0;
    left: 0;
    margin-bottom: 15px;
  }

  button {
    height: 34px;
    width: 130px;
    position: absolute;
    top: calc(75%);
    left: calc(50% - 65px);
  }
`;
